// src/lib/capture/audioMime.ts — map a recorder MIME type to a storage file extension.
//
// The captured audio's container/codec varies by platform (native Android/iOS → audio/aac; Chrome /
// Firefox → audio/webm; Safari → audio/mp4), so the object we upload must carry an extension that
// matches its bytes. BOTH the foreground upload path (CaptureSheet) and the offline reconnect-drain
// path (drainCaptures) derive the extension through THIS single helper, so a queued capture and a live
// capture always build the same object-key shape (they were previously hardcoded to `.webm` in two
// places and had to be kept in sync by hand). The transcription pipeline sniffs the bytes, so the
// extension is descriptive rather than authoritative — but it must still match the payload.

/**
 * File extension (with leading dot) for a recorder MIME type. AAC is written into an MP4/M4A container
 * on native, so audio/aac and audio/mp4 both map to `.m4a`. Falls back to `.webm` (the web
 * MediaRecorder default) for anything unrecognised.
 */
export function audioExtensionForMime(mimeType: string | undefined | null): string {
  const t = (mimeType ?? '').toLowerCase();
  if (t.includes('aac') || t.includes('mp4') || t.includes('m4a')) return '.m4a';
  if (t.includes('webm')) return '.webm';
  if (t.includes('ogg')) return '.ogg';
  if (t.includes('mpeg') || t.includes('mp3')) return '.mp3';
  if (t.includes('wav')) return '.wav';
  return '.webm';
}
